// src/Components/Includes/Generator/Download/DownloadButtons.js
import React from "react";
import ResolutionModal from "./ResolutionModal";
import useQrCodeDownload from "../../../../hooks/useQrCodeDownload";
import useSendQrCodeByEmail from "../../../../hooks/useSendQrCodeByEmail";
import PixCopiaCola from "../Pix/PixCopiaCola"; // Certifique-se de que o caminho está correto

const DownloadButtons = ({ qrCode, toggleModal, data, options, type, setQrData }) => {
    const appSiteUrl = process.env.REACT_APP_SITE_URL;
    const appApiUrl = process.env.REACT_APP_EMAIL_API_URL;
    const endPointSendEmailQrCode = process.env.REACT_APP_ENDPOINT_SEND_EMAIL_QR_CODE;

    const {
        isResolutionModalOpen,
        handleDownload,
        handleResolutionDownload,
        setIsResolutionModalOpen,
        downloadExtension
    } = useQrCodeDownload(qrCode, data, type, options, appSiteUrl);

    const { handleSendEmail } = useSendQrCodeByEmail(qrCode, data, type, options, appSiteUrl, appApiUrl, endPointSendEmailQrCode);

    return (
        <div>
            <div className="download-buttons">
                <button className="btn-download" onClick={() => handleDownload('jpg')}>JPG</button>
                <button className="btn-download btn-download-premium" onClick={() => toggleModal()}>PNG</button>
                <button className="btn-download btn-download-premium" onClick={() => toggleModal()}>PDF</button>
                <button className="btn-download btn-download-premium" onClick={() => toggleModal()}>SVG</button>
            </div>
            <ResolutionModal
                isOpen={isResolutionModalOpen}
                onClose={() => setIsResolutionModalOpen(false)}
                onDownload={handleResolutionDownload}
                onSendEmail={(resolution, email) => handleSendEmail(resolution, email, downloadExtension)}
            />
            {type === "pix" && (
                <PixCopiaCola qrData={data} />
            )}
        </div>
    );
};

export default DownloadButtons;